import { Component, OnInit } from '@angular/core';
import { DataGridTemplate } from '../../../../../shared/data-grid/data-grid.template';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormDialogTemplate } from '../../../../../shared/form-dialog/form-dialog.template';
import { BehaviorSubject } from 'rxjs';
import { CtwrProgramService } from '../../../ctwr.service';

@Component({
  selector: 'app-programs',
  templateUrl: './programs.component.html',
  styleUrls: ['./programs.component.scss']
})
export class ProgramsComponent extends DataGridTemplate implements OnInit {

  editForm: FormGroup;
  formDialog: FormDialogTemplate;

  dialogTitle: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly programService: CtwrProgramService
  ) {
    super();
    this.controls.edit = false;
  }

  ngOnInit() {
    this.formDialog = new FormDialogTemplate();
    this.modal = true;
    this.sortable = true;
    this.filterable = 'menu';
    this.gridState.sort = [{ dir: 'asc', field: 'Name' }];

    this.editForm = this.formBuilder.group({
      Id: [],
      Name: ['', Validators.compose([Validators.required, Validators.maxLength(65)])],
    })
    this.formDialog.notificationLabel = { flag: 'info', state: 'edit', value: '*Editing this record may impact current, future, and past requests.' };

    this.formDialog.initilize(this.dialogTitle, this.editForm, this.formDialogTabs);
  }


  create(parentEditDataItem: any): void {
    this.formDialog.isNew = true;
    this.formDialog.next(this.editDataItem);
    this.dialogTitle.next('Program');

  }


  read(opts: any): Promise<any> {
    return opts.force ?
      this.programService.read('') :
      Promise.resolve(this.programService.value);
  }


  edit(dataItem: any): void {
  }


  save(dataItem: any, isNew: boolean): Promise<any> {
    return isNew ? this.programService.save(this.editForm.value, isNew) :
      this.programService.save(this.editForm.value, isNew, `/${dataItem.Id}`, false);
  }


  delete(dataItem: any): Promise<any> {
    return this.programService.remove(`/${dataItem.Id}`, false);
  }


  columns: any[] = [
    {
      field: 'Name',
      title: 'Name',
    },
  ]

  formControls = [
    {
      type: 'text',
      title: 'Program Name',
      name: 'Name',
      textField: 'Description',
      valueField: 'Id',
      placeholder: 'Enter a Program Name',
      stretch: true,
      invalidText: 'Invalid Input. Name must be between 1 and 65 characters.',
    },
  ]

  formDialogTabs = [
    {
      title: "Programs",
      selected: true,
      formControls: this.formControls
    },
  ]
}
